class AppContext {

    constructor() {
        this.registerMessageHandler = this.registerMessageHandler.bind(this);
        this.discardMessageHandler = this.discardMessageHandler.bind(this);
        this.message = this.message.bind(this);
        
        this._trackedHref = new Set();

        this.trackedHref = this.trackedHref.bind(this);
    }

    isAuthenticated() {
        return window.__ap_appContext.isAuthenticated;
    }

    aiKey() {
        return window.__ap_appContext.aiKey;
    }

    root(value) {
        if (value) {
            while (value.endsWith("/")) value = value.substring(0, value.length - 1);
            window.__ap_appContext.root = value;
        }
        return window.__ap_appContext.root;
    }

    logoUrl(value) {
        if (value) {
            window.__ap_appContext.logoUrl = value;
        }
        return window.__ap_appContext.logoUrl;
    }

    /**
     * 
     * @param {string[]} hrefs 
     * @return {Set<string>}
     */
    trackedHref(hrefs) {
        if (hrefs) {
            this._trackedHref = new Set();
            for(const href of hrefs) {
                this._trackedHref.add(href.toLowerCase());
            }
        }
        return this._trackedHref;
    }

    appRoot(value) {
        if (value) {
            while (value.endsWith("/")) value = value.substring(0, value.length - 1);
            window.__ap_appContext.appRoot = value;
        }
        return window.__ap_appContext.appRoot;
    }

    apiRoot(value) {
        if (value) {
            while (value.endsWith("/")) value = value.substring(0, value.length - 1);
            window.__ap_appContext.apiRoot = value;
        }
        return window.__ap_appContext.apiRoot;
    }

    legacyRoot(value) {
        if (value) {
            while (value.endsWith("/")) value = value.substring(0, value.length - 1);
            window.__ap_appContext.legacyRoot = value;
        }
        return window.__ap_appContext.legacyRoot;
    }

    copyright(value) {
        if (value) {
            window.__ap_appContext.copyright = value;
        }
        return window.__ap_appContext.copyright;
    }

    routeUrl() {
        let root = window.__ap_appContext.appRoot;
        while (root.endsWith("/")) root = root.substring(0, root.length - 1);

        let url = root;

        for (let i = 0; i < arguments.length; i++) {
            let potion = arguments[i];
            while (potion.startsWith("/")) potion = potion.substring(1, potion.length);
            url = `${url}/${potion}`;
        }

        return url;
    }

    url() {
        let root = window.__ap_appContext.root;
        while (root.endsWith("/")) root = root.substring(0, root.length - 1);

        let url = root;

        for (let i = 0; i < arguments.length; i++) {
            let potion = arguments[i];
            while (potion.startsWith("/")) potion = potion.substring(1, potion.length);
            url = `${url}/${potion}`;
        }

        return url;
    }

    registerMessageHandler(messageHandler) {
        this.messageHandler = messageHandler;
    }

    discardMessageHandler() {
        this.messageHandler = null;
    }

    message(msg, callback, state) {
        this.messageHandler(msg, callback, state);
    }

    getRouteParam(target, paramName) {
        if (target.props.route) {
            return target.props.route[paramName];
        } else {
            const routes = target.props.routes;
            return routes[routes.length - 1][paramName];
        }
    }

    redirectToHome() {
        window.location = context.routeUrl("home");
    }

    resolveMsg(code) {
        console.log(code);
        switch (parseInt(code)) {
            case 1: return "Session timeout, please login.";
            default: return null;
        }
    }
}

var context = new AppContext();

export default context;